import { useFlags } from "launchdarkly-react-client-sdk";

import { useEntitlements } from "src/hooks/use-entitlement";
import { useOrganizationEntitlement } from "src/hooks/use-organization-entitlement";

export const useIsAdStudioEnabled = () => {
  const { appAdStudio } = useFlags();
  // Two reads of the same entitlement, deliberately — same pattern as
  // use-agents-tier. The server's is the only one that sees a staff grant from
  // the Entitlement Center; grants live in the entitlement_grants table, which
  // the org entitlements jsonb knows nothing about. The jsonb read is
  // synchronous, so it keeps this answering correctly before the query resolves
  // rather than reporting "off" and bouncing users out of the Ad Studio routes
  // on first render.
  const hasAdStudioEntitlement = useOrganizationEntitlement("adStudio");
  const { data } = useEntitlements(true);

  return !!appAdStudio || hasAdStudioEntitlement || data.entitlements.adStudio;
};
